import {
  FETCH_COLLECTION_NAMES_START,
  FETCH_COLLECTION_NAMES_SUCCESS,
  FETCH_COLLECTION_NAMES_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  collectionNames: [],
  isFetching: false,
  errorMessage: '',
}

const collectionNamesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COLLECTION_NAMES_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_COLLECTION_NAMES_SUCCESS:
      return {
        ...state,
        collectionNames: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_COLLECTION_NAMES_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default collectionNamesReducer
